import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';

import { StaticRoutingModule } from './static-routing.module';
import { BlockDiagramEditorComponent } from './blockDiagramEditor/blockDiagramEditor.component';
import { FeaturesComponent } from './features/features.component';

@NgModule({
  imports: [SharedModule, StaticRoutingModule],
  declarations: [BlockDiagramEditorComponent, FeaturesComponent]
})
export class StaticModule {}
